import { render, staticRenderFns } from "./videorecord.vue?vue&type=template&id=edd308da&scoped=true&"
import script from "./videorecord.vue?vue&type=script&lang=js&"
export * from "./videorecord.vue?vue&type=script&lang=js&"
import style0 from "./videorecord.vue?vue&type=style&index=0&id=edd308da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd308da",
  null
  
)

export default component.exports